import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiOriginalsResponse } from '@wix/da-papi-types';
import StudioScheduled from '@wix/da-ds/pkg/Icons/16x16/StudioScheduled';
import { useStream } from '@wix/da-shared-react/pkg/utils/hooks/useStream';
import OrdersList from '../OrdersList';
import OrdersByStatusEmptyState from '../../OrdersByStatusEmptyState';
import OrdersSectionTitle from '../../OrdersSectionTitle';
import { STUDIO_ORDERS_PENDING_STREAM } from '../../../../../constants';

const PendingOrdersList: React.FC = () => {
  const { t } = useTranslation();
  const {
    items: results,
    hasMore,
    fetchNext,
  } = useStream<PapiOriginalsResponse>(
    STUDIO_ORDERS_PENDING_STREAM.streamId,
    STUDIO_ORDERS_PENDING_STREAM.streamThrottle,
    STUDIO_ORDERS_PENDING_STREAM.streamConfig
  );

  if (results.length < 1) {
    return (
      <OrdersByStatusEmptyState
        headerTitle={t('studio.orders.status.pending')}
        headerIcon={StudioScheduled}
        text={t('studio.orders.status.pending.emptyState')}
      />
    );
  }

  return (
    <OrdersList
      heading={
        <OrdersSectionTitle
          title={t('studio.orders.status.pending')}
          icon={StudioScheduled}
        />
      }
      hasMore={hasMore}
      results={results}
      fetchNext={fetchNext}
    />
  );
};
PendingOrdersList.displayName = 'PendingOrdersList';

export default PendingOrdersList;
